<template>
 <v-app-bar
      app
      class="afterpay"
    >
      <div class="d-flex align-center">
        <router-link to="/">
          <v-img
            alt="Vuetify Name"
            class="shrink mt-1"
            contain
            min-width="100"
            :src="require('../assets/Afterpay logo black no marginsmall.png')"
            width="120"
          />
        </router-link>
      </div>
      <v-spacer></v-spacer>
      <div v-for="item in items" :key="item.name" >
        <v-btn v-if="item.to" :to="item.to" text>
          <span class="mr-2">{{item.name}}</span>
        </v-btn>
        <v-btn v-else-if="item.href" :href="item.href" target="_blank" text>
          <span class="mr-2" >{{item.name}}</span>
        </v-btn>
        <v-btn v-else v-bind:href="'mailto:' + email" text>
          <span class="mr-2" >{{item.name}}</span>
          <v-icon>{{item.icon}}</v-icon>
        </v-btn>
      </div>
    </v-app-bar>
</template>

<script>
export default {
  name: "appbar",
  data() {
    return{
      items:[
          {name:"Home", to:"/"},
          {name:"Directory", to:"/mindmap"},
          {name:"Search", href:"https://script.google.com/a/afterpay.com/macros/s/AKfycbxxe9DD6yXRQbg1IOc0IWVyBW-cb-ZNStpdH-pGZZGX8ahJ_04/exec"},
          {name:"Tutorial", to:"/tutorial"},
          // {name:"Tutorial", href:'https://sites.google.com/afterpay.com/tableau-search-bi/general-training'},
          {name:"Contact us", icon:"mdi-email-outline"}
      ],
      email:this.$email
    }
  }
}
</script>

<style scoped>

</style>
